import { RequiredKeysOf } from 'type-fest'
import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent, OpalApiRequestBody } from '../../schema'

type RequestAttributes =
  OpalApiRequestBody<'CreateMomentV3'>['data']['attributes']
type RequestRelationships =
  OpalApiRequestBody<'CreateMomentV3'>['data']['relationships']

type OptionalAttributes = Omit<
  OpalApiComponent<'V3', 'moment'>['attributes'],
  RequiredKeysOf<RequestAttributes>
>

const defaultBoardAttributes: OptionalAttributes = {
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  color: null,
  content_count: 0,
  is_ghost: false,
  legacy_id: '',
}

export const resourceObject = ({
  attributes,
  relationships,
}: {
  attributes: RequestAttributes
  relationships: RequestRelationships
}): OpalApiComponent<'V3', 'moment'> => {
  const randomId = Math.floor(Math.random() * 1000).toString()
  return {
    id: uuidv4(),
    type: 'moment',
    attributes: {
      ...defaultBoardAttributes,
      ...attributes,
      legacy_id: randomId,
    },
    relationships: {
      // It would be better to use the current user's real id, but doing that requires a ton of edits, and it's just not
      // worth the effort unless this causes problems.
      //
      // Like, first you have to update the three places that call `resourceObject` (as `moments.clientResource`) to
      // have an `owner` in `relationships`; each of the three must then be updated to *take* the user UUID as an
      // argument, which means updating all of *their* callsites, and the whole thing quickly spirals.
      //
      // Plus: for strict accuracy `resourceObject`'s arguments should use the response schema, not the request schema,
      // but that changes which attributes must be passed, requiring even further edits.
      owner: {
        data: {
          id: uuidv4(),
          type: 'user',
        },
      },
      primary_story: {
        data:
          Array.isArray(relationships.stories?.data) &&
          relationships.stories.data.length > 0
            ? relationships.stories.data[0]
            : null,
      },
      ...relationships,
    },
    links: {
      v2_request: new URL(
        `/moments/v2/${randomId}`,
        window.location.origin
      ).toString(),
    },
  }
}
